module.exports = __webpack_public_path__ + "media/rickroll.ffd3d2ea.mp3";